import { render, staticRenderFns } from "./Customersitelist.vue?vue&type=template&id=b90e98f0"
import script from "./Customersitelist.vue?vue&type=script&lang=js"
export * from "./Customersitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports